import React from 'react';
import { useMutation } from '@apollo/client';
import SaveAsUserMealMutation from './SaveAsUserMealMutation';
import FetchUserMealsQuery from '../Fetch/FetchUserMealsQuery';

interface ISaveAsUserMealConnectorApolloProps {
  children: ({
    saveAsUserMeal,
  }: {
    saveAsUserMeal: (input: any) => Promise<any>;
  }) => React.ReactElement;
  post: any;
}

const SaveAsUserMealConnectorApollo: React.FC<ISaveAsUserMealConnectorApolloProps> = ({
  children,
  post,
}) => {
  const [saveAsUserMealMutation] = useMutation(SaveAsUserMealMutation);

  const saveAsUserMeal = async (input: any) => {
    const response = await saveAsUserMealMutation({
      variables: { input },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: FetchUserMealsQuery,
        },
      ],
    });

    if (post) {
      console.log('reload webview');
      post('reload');
    }

    return response.data.dailyTracker.saveAsUserMeal;
  };
  return children({ saveAsUserMeal });
};

export default SaveAsUserMealConnectorApollo;
